// @ts-check
import dinLight from '../fonts/300.js';
import dinMedium from '../fonts/500.js';
import dinBold from '../fonts/700.js';

/** @type {import('../../../pdf-design-system/useTheme').BottlebooksPDFTheme["theme"]} */
const theme = {
  colors: { primary: '#999', onPrimary: 'white', text: 'rgb(84, 86, 86)' },
  components: {
    Text: {
      base: { ...dinLight },
      default: { fontSize: 44, lineHeight: 64 / 44 },
      large: { ...dinMedium, fontSize: 55, lineHeight: 64 / 55 },
    },
    Title: {
      base: { ...dinBold, textTransform: 'uppercase' },
      default: {
        fontSize: 90,
        lineHeight: 86 / 90,
      },
      small: {
        fontSize: 75,
        lineHeight: 80 / 75,
      },
      smallest: {
        fontSize: 65,
        lineHeight: 74 / 65,
      },
      large: {
        fontSize: 120,
        lineHeight: 1,
      },
    },
  },
};

export default theme;
